import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "input",
    "counter",
    "imageContainer",
    "imageInput",
    "preview",
    "destroy",
    "imagesContainer",
  ]

  connect() {
    this.updateCounter()
  }

  openCamera(event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  handlePhotos(event) {
    const files = event.target.files

    Array.from(files).forEach((file) => {
      const reader = new FileReader()

      reader.onload = (e) => {
        const base64String = e.target.result
        this.addNewImageField(base64String)
      }

      reader.readAsDataURL(file)
    })
  }

  addNewImageField(base64String) {
    const timestamp = new Date().getTime()
    const containerHTML = `
      <div class="relative" data-photo-upload-target="imageContainer">
        <input type="hidden" 
               name="task_closure_data[task_closure_images_attributes][${timestamp}][image]" 
               value="${base64String}"
               data-photo-upload-target="imageInput">
        <input type="hidden"
               name="task_closure_data[task_closure_images_attributes][${timestamp}][_destroy]"
               value="0"
               data-photo-upload-target="destroy">
        <div class="aspect-w-1 aspect-h-1 w-full overflow-hidden rounded-lg bg-gray-200">
          <img src="${base64String}"
               class="h-full w-full object-cover" 
               data-photo-upload-target="preview">
        </div>
        <button type="button" 
                class="absolute top-2 right-2 p-1 rounded-full bg-bautask-green text-white hover:bg-bautask-dark"
                data-action="click->photo-upload#removeImage">
          <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    `

    const template = document.createElement("template")
    template.innerHTML = containerHTML.trim()
    const newContainer = template.content.firstChild

    this.imagesContainerTarget.appendChild(newContainer)
    this.updateCounter()
  }

  removeImage(event) {
    const container = event.target.closest('[data-photo-upload-target="imageContainer"]')
    const destroyInput = container.querySelector('[data-photo-upload-target="destroy"]')

    if (destroyInput) {
      destroyInput.value = "1"
      container.style.display = "none"
    } else {
      container.remove()
    }

    this.updateCounter()
  }

  updateCounter() {
    const visibleImages = this.imageContainerTargets.filter(
      (container) => container.style.display !== "none",
    ).length

    const button = document.querySelector('[data-controller="submit-button"]')

    if (visibleImages >= 4) {
      button.disabled = false
      button.classList.remove("opacity-50", "cursor-not-allowed")
    } else {
      button.disabled = true
      button.classList.add("opacity-50", "cursor-not-allowed")
    }

    this.counterTarget.innerHTML = `${visibleImages} von 4 Fotos hochgeladen`
  }
}
